import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Views - Charts
const Charts = () => import('@/views/charts/Charts')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Company = () => import('@/views/pages/Company')
const Signup = () => import('@/views/pages/Signup')

//View - Menus
const Menus       = () => import('@/views/menu/MenuIndex')
const CreateMenu  = () => import('@/views/menu/CreateMenu')
const EditMenu    = () => import('@/views/menu/EditMenu')
const DeleteMenu  = () => import('@/views/menu/DeleteMenu')

//View - MenuElements
const MenuElements = () => import('@/views/menuElements/ElementsIndex')
const CreateMenuElement = () => import('@/views/menuElements/CreateMenuElement')
const EditMenuElement = () => import('@/views/menuElements/EditMenuElement')
const ShowMenuElement = () => import('@/views/menuElements/ShowMenuElement')
const DeleteMenuElement = () => import('@/views/menuElements/DeleteMenuElement')

const QuestionForm = () => import('@/views/questionnaire/QuestionForm')
const Survey = () => import('@/views/questionnaire/Survey')
const AnswerForm = () => import('@/views/questionnaire/AnswerForm')
const Home = () => import('@/views/client/Home')
const ViewAnswer = () => import('@/views/client/ViewAnswer')
const PowerCurve = () => import('@/views/client/PowerCurve')
const NetworkPower = () => import('@/views/client/NetworkPower')

const ExportUser = () => import('@/views/admin/ExportUser')

//View - List Data
const ListCompanies = () => import('@/views/category/CategoryView')

//Pages - User profile
const UserProfile = () => import('@/views/pages/UserProfile')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')
const ResetPassword = () => import('@/views/pages/ResetPassword')

const Users = () => import('@/views/pages/User')


Vue.use(Router)

let router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})

router.beforeEach((to, from, next) => {
    let roles = localStorage.getItem("roles");
    if(roles != null){
        roles = roles.split(',')
    }
    if(to.matched.some(record => record.meta.requiresAdmin)) {
        if(roles != null && (roles.indexOf('admin') >= 0 || roles.indexOf('superadmin') >= 0)){
            next()
        }else{
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        }
    }
    else if(to.matched.some(record => record.meta.requiresUser)) {
        if(roles != null && roles.indexOf('client') >= 0 ){
            next()
        }else{
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        }
    }else{
        next()
    }
})

export default router

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    meta: {
                        requiresAdmin: true
                    }
                },
                {
                    path: 'home',
                    name: 'Home',
                    component: Home,
                    meta: {
                        // requiresAdmin: true,
                        requiresUser: true
                    }
                },
                {
                    path: 'view-answer',
                    name: 'ViewAnswer',
                    component: ViewAnswer,
                    meta: {
                        // requiresAdmin: true,
                        requiresUser: true
                    }
                },
                {
                    path: 'charts',
                    name: 'Charts',
                    component: Charts,
                    meta:{
                        // requiresUser: true
                        requiresAdmin: true
                    }
                },
                {
                    path: 'survey',
                    name: 'Survey',
                    component: Survey,
                    meta:{
                        requiresAdmin: true
                    }
                },
                {
                  path: 'answer',
                  name: 'AnswerForm',
                  component: AnswerForm,
                  meta: {
                      requiresUser: true
                      // requiresAdmin: true
                  }
                },
                {
                    path: 'list',
                    name: 'ListCompanies',
                    component: ListCompanies,
                    meta: {
                        requiresAdmin: true
                    }
                },
                {
                  path: 'profile',
                  name: 'UserProfile',
                  component: UserProfile
                },
                {
                    path: 'menu',
                    meta: { label: 'Menu'},
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Menus,
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: 'create',
                            meta: { label: 'Create Menu' },
                            name: 'CreateMenu',
                            component: CreateMenu,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':id/edit',
                            meta: { label: 'Edit Menu' },
                            name: 'EditMenu',
                            component: EditMenu,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':id/delete',
                            meta: { label: 'Delete Menu' },
                            name: 'DeleteMenu',
                            component: DeleteMenu,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                    ]
                },
                {
                    path: 'menuelement',
                    meta: { label: 'MenuElement'},
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: ':menu/menuelement',
                            component: MenuElements,
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':menu/menuelement/create',
                            meta: { label: 'Create Menu Element' },
                            name: 'Create Menu Element',
                            component: CreateMenuElement,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':menu/menuelement/:id',
                            meta: { label: 'Menu Element Details'},
                            name: 'Menu Element',
                            component: ShowMenuElement,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':menu/menuelement/:id/edit',
                            meta: { label: 'Edit Menu Element' },
                            name: 'Edit Menu Element',
                            component: EditMenuElement,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                        {
                            path: ':menu/menuelement/:id/delete',
                            meta: { label: 'Delete Menu Element' },
                            name: 'Delete Menu Element',
                            component: DeleteMenuElement,
                            // eslint-disable-next-line no-dupe-keys
                            meta:{
                                requiresAdmin: true
                            }
                        },
                    ]
                },
                {
                    path: 'users',
                    name: 'Users',
                    component: Users,
                    meta: {
                        requiresAdmin: true
                    }
                },
                {
                    path:'power-curve',
                    name: 'Power Curve',
                    component: PowerCurve,
                    meta: {
                        requiresUser: true
                    }
                },
                {
                    path:'export-company',
                    name: 'Export Company',
                    component: ExportUser,
                    meta: {
                        requiresAdmin: true
                    }
                },
                {
                    path:'network-power',
                    name: 'Network Power',
                    component: NetworkPower,
                    meta: {
                        requiresUser: true
                    }
                }
            ]
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render (c) { return c('router-view') }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
            ]
        },
        {
            path: '/',
            redirect: '/login',
            name: 'Auth',
            component: {
                render (c) { return c('router-view') }
            },
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                },
                {
                    path: 'company',
                    name: 'Company',
                    component: Company
                },
                {
                    path: 'forgot-password',
                    name: 'ForgotPassword',
                    component: ForgotPassword
                },
                {
                    path: 'reset-password',
                    name: 'ResetPassword',
                    component: ResetPassword
                },
                {
                    path: 'questionForm',
                    name: 'QuestionForm',
                    component: QuestionForm
                },
                {
                    path: 'signup',
                    name: 'Signup',
                    component: Signup
                }
            ]
        },
        {
            path: '*',
            name: '404',
            component: Page404
        }
    ]
}
